// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__naxwQ","buttons":"styles_buttons__1ygY5"};